module.exports = __webpack_public_path__ + "img/req_cus_hui_bg.23fc5804.png";